const buildSearch = ({ eventId, occurredAt } = {}) => {
  const params = new URLSearchParams()

  if (eventId) params.set('eventId', eventId)
  if (occurredAt) params.set('occurredAt', occurredAt)
  params.set('previousPath', window.location.pathname + window.location.search)

  const query = params.toString()

  return query ? `?${query}` : ''
}

export default buildSearch
